import React from 'react';
interface ChatMessageProps {
  sender: 'ai' | 'student';
  name: string;
  message: string;
  timestamp: string;
  avatarInitials: string;
  avatarColor?: string;
}
export function ChatMessage({
  sender,
  name,
  message,
  timestamp,
  avatarInitials,
  avatarColor = '#8a38f5'
}: ChatMessageProps) {
  const isAi = sender === 'ai';
  return <div className={`flex w-full mb-6 ${isAi ? 'justify-start' : 'justify-end'}`} data-id="element-56">
      <div className={`flex max-w-[80%] ${isAi ? 'flex-row' : 'flex-row-reverse'}`} data-id="element-57">
        {/* Avatar */}
        <div className="flex-shrink-0 h-10 w-10 rounded-full flex items-center justify-center text-white text-sm font-medium mt-1" style={{
        backgroundColor: avatarColor
      }} data-id="element-58">
          {avatarInitials}
        </div>

        {/* Message Content */}
        <div className={`flex flex-col ${isAi ? 'ml-3 items-start' : 'mr-3 items-end'}`} data-id="element-59">
          <span className="text-sm text-gray-500 mb-1" data-id="element-60">{name}</span>

          <div className={`p-4 rounded-2xl text-[15px] leading-relaxed shadow-sm ${isAi ? 'bg-[#f3f1f6] text-[#1e1e1e] rounded-tl-none' : 'bg-[#8a38f5] text-white rounded-tr-none'}`} data-id="element-61">
            {message}
          </div>

          <span className="text-xs text-gray-400 mt-1" data-id="element-62">{timestamp}</span>
        </div>
      </div>
    </div>;
}